export const AppRoutingLogin = 'login';
export const AppRoutingSelect = 'select';
export const AppRoutingPasswordReset = 'password-reset';
export const AppRoutingPasswordResetMail = 'mail';
export const AppRoutingPasswordResetOtp = 'otp';
export const AppRoutingPasswordResetOtpSessionExpired = 'session-expired';
export const AppRoutingPasswordResetOtpNewPassword = 'new-password';
export const AppRoutingPasswordResetOtpPasswordChanged = 'password-changed';
